import React, { useState, useEffect } from 'react'
import moment from 'moment'
import ReactGA from 'react-ga'
import { isEmpty } from 'lodash'
import { useRequest } from '../utils/hooks'
import DialogEstabelecimento from './DialogEstabelecimento'
import EstabelecimentosComponent from '../components/EstabelecimentosComponent'
// import { estabelecimentos } from '../constants/estabelecimentos'

const EstabelecimentosList = ({
  searchParams,
  estabelecimentosState,
  setEstabelecimentosState,
  pagination,
  setPagination,
  pageProps,
}) => {
  const urlParams = new URLSearchParams(window.location.search)
  const [dialogEstabelecimento, setDialogEstabelecimento] = useState({
    isOpen: false,
    data: null,
  })

  const [
    estabelecimentos,
    statusRequestEstabelecimentos,
    fetchEstabelecimentos,
  ] = useRequest(
    [],
    {
      url: `estabelecimentos`,
      method: 'get',
      params: !isEmpty(searchParams)
        ? {
            params: {
              order_by: 'nome',
              nome: searchParams.estabelecimento,
              cidade: searchParams.cidade,
              bairro: searchParams.bairro,
              id_categoria_estabelecimento:
                searchParams.servico === 'none' ? '' : searchParams.servico,
              ativo: true,
              negocio: true,
            },
            currentPage: 0,
            pageSize: 300,
          }
        : { ...pagination, params: { order_by: 'nome', ativo: true, negocio: true } },
      // params: {
      //   currentPage: !isEmpty(searchParams) ? 0 : pagination.currentPage,
      //   pageSize: !isEmpty(searchParams) ? 300 : pagination.pageSize,
      //   params: {
      //     nome: searchParams.estabelecimento,
      //     cidade: searchParams.cidade,
      //     id_categoria_estabelecimento:
      //       searchParams.servico === 'none' ? null : searchParams.servico,
      //   },
      // },
    },
    null,
    {
      onComplete: (data) => {
        if (!isEmpty(searchParams)) {
          setEstabelecimentosState(data.rows)
          setPagination({ ...pagination, currentPage: 0 })
        } else {
          setPagination({
            ...pagination,
            currentPage: pagination.currentPage + 1,
          })
          setEstabelecimentosState([...estabelecimentosState, ...data.rows])
        }
      },
    }
  )

  const [, , fetchEstabelecimento] = useRequest(
    [],
    {
      url: `estabelecimentos/${urlParams.get('estabelecimento')}`,
      method: 'get',
      params: {
        id: urlParams.get('estabelecimento'),
      },
    },
    null,
    {
      onComplete: (data) => {
        if (data.id) {
          setDialogEstabelecimento({
            isOpen: true,
            data: data,
          })

          ReactGA.event({
            category: pageProps.title,
            action: 'Opened shared estabelecimento',
          })
        }
      },
    }
  )

  useEffect(() => {
    fetchEstabelecimentos()

    if (urlParams.get('estabelecimento')) {
      fetchEstabelecimento()
    }
  }, [])

  useEffect(() => {
    if (searchParams) {
      fetchEstabelecimentos()
    }
  }, [searchParams])

  return (
    <>
      <EstabelecimentosComponent
        setDialogEstabelecimento={setDialogEstabelecimento}
        estabelecimentosState={estabelecimentosState || []}
        estabelecimentos={estabelecimentos}
        statusRequestEstabelecimentos={statusRequestEstabelecimentos}
        fetchEstabelecimentos={fetchEstabelecimentos}
        searchParams={searchParams}
        pageProps={pageProps}
      />

      <DialogEstabelecimento
        dialog={dialogEstabelecimento}
        setDialog={setDialogEstabelecimento}
        pageProps={pageProps}
      />
    </>
  )
}

export default EstabelecimentosList
